module.exports = __webpack_public_path__ + "img/taotanlogo_back.2798521a.png";